import { createContext, use, type ReactNode } from "react";
import {
  unavailableSupport,
  type SupportClient,
} from "@/lib/support/support-client";

/**
 * Defaults to the client with nowhere to send, so a tree with no provider
 * renders rather than failing, and a send says Support is unavailable: the
 * header is rendered in harnesses that know nothing of Support, and none of
 * them should have to.
 */
const SupportContext = createContext<SupportClient>(unavailableSupport);

/**
 * The client is passed in rather than built here, so a test can hand the tree
 * a fake and the composition root stays the only place that knows which one is
 * real.
 */
export function SupportProvider({
  client,
  children,
}: {
  client: SupportClient;
  children: ReactNode;
}) {
  return <SupportContext value={client}>{children}</SupportContext>;
}

export function useSupport(): SupportClient {
  return use(SupportContext);
}
